const mapToUppercase = (arr: string[]) => arr.map((item) => item.toUpperCase());

export default mapToUppercase;
